var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"flex justify-between items-center px-4"},[_vm._m(0),(!_vm.noBreadcrumb)?_c('MBreadcrumb'):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4"},[_c('img',{staticClass:"h-12",attrs:{"src":"https://automatuslab.blob.core.windows.net/macro/VIVO/CHAT-BOT/CONTROLE%20B2B/logo.png"}})])
}]

export { render, staticRenderFns }